import React from "react";
import { ImCross } from "react-icons/im";
import { useDispatch } from "react-redux";
import {
  deleteItem,
  drecreaseQuantity,
  increaseQuantity,
} from "../../redux/rkglobaltradeSlice";

const ItemCard = ({ item }) => {
  const dispatch = useDispatch();

  return (
    <div className="w-full grid grid-cols-5 mb-4 border py-2 bg-white rounded-md shadow-sm">
      {/* Product Info */}
      <div className="flex col-span-5 mdl:col-span-2 items-center gap-4 ml-4">
        <ImCross
          onClick={() => dispatch(deleteItem(item._id))}
          className="text-primeColor hover:text-red-500 duration-300 cursor-pointer"
          title="Remove product from cart"
          aria-label={`Remove ${item.name} from cart`}
        />
        <img
          className="w-32 h-32 object-cover rounded-md"
          src={item.image}
          alt={`${item.name} - Agriculture Product Export from India`}
          title={item.name}
        />
        <h1 className="font-titleFont font-semibold text-gray-800">{item.name}</h1>
      </div>

      {/* Price, Quantity & Subtotal */}
      <div className="col-span-5 mdl:col-span-3 flex items-center justify-between py-4 mdl:py-0 px-4 mdl:px-0 gap-6 mdl:gap-0">
        {/* Price */}
        <div className="flex w-1/3 items-center text-lg font-semibold text-primeColor">
          ${item.price.toFixed(2)}
        </div>

        {/* Quantity Controls */}
        <div className="w-1/3 flex items-center gap-6 text-lg">
          <span
            onClick={() => dispatch(drecreaseQuantity({ _id: item._id }))}
            className="w-6 h-6 bg-gray-100 text-2xl flex items-center justify-center hover:bg-gray-300 cursor-pointer duration-300 border border-gray-300"
            title="Decrease quantity"
            aria-label={`Decrease quantity of ${item.name}`}
          >
            -
          </span>
          <p className="font-medium">{item.quantity}</p>
          <span
            onClick={() => dispatch(increaseQuantity({ _id: item._id }))}
            className="w-6 h-6 bg-gray-100 text-2xl flex items-center justify-center hover:bg-gray-300 cursor-pointer duration-300 border border-gray-300"
            title="Increase quantity"
            aria-label={`Increase quantity of ${item.name}`}
          >
            +
          </span>
        </div>

        {/* Subtotal */}
        <div className="w-1/3 flex items-center font-titleFont font-bold text-lg text-gray-900">
          <p>${(item.quantity * item.price).toFixed(2)}</p>
        </div>
      </div>
    </div>
  );
};

export default ItemCard;
